export const formatNumber = (num) => {
  if (num == null) return '0';
  return Number(num).toLocaleString();
};

export const formatCurrency = (num) => {
  if (num == null) return '0.00';
  return Number(num).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};
